import React from 'react';
import { connect } from 'react-redux';
// Level editor imports
import { toggleMoveMode } from '../../../../../../actions/levelEditorActions';
// Game(kit) imports
import gameKit from '../../../../../../../GameKit';
// Shared imports
import { LevelEditorModeEnum } from '../../../../../../shared';
import settings from '../../../../../../../settings';

class BtnMoveMode extends React.Component {
    handleClick = () => {
        // Toggle move mode
        const { dispatch } = this.props;
        dispatch(toggleMoveMode());

        const { levelEditor } = this.props;
        if (levelEditor.mode !== LevelEditorModeEnum.MOVE) {
            gameKit.levelEditor.exitMoveMode();
        } else {
            gameKit.levelEditor.startMoveMode();
        }
    };

    Img = () => {
        return <img src={`${settings.assetsPath}img/icons/screensize_black.png`} alt="Beweeg modus" title="Beweeg modus" />;
    };

    MoveModeButton = () => {
        return (
            <button className="btn-move-toggle is-move-mode" type="button" onClick={this.handleClick}>
                <this.Img />
            </button>
        );
    };

    ItemSelectorButton = () => {
        return (
            <button className="btn-move-toggle" type="button" onClick={this.handleClick}>
                <this.Img />
            </button>
        );
    };

    render = () => {
        const { isMoveMode } = this.props;

        if (isMoveMode) {
            return <this.MoveModeButton />;
        }
        return <this.ItemSelectorButton />;
    };
}

BtnMoveMode.defaultProperties = {
    isMoveMode: false
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BtnMoveMode);
